import { render, staticRenderFns } from "./certificateMaterialCategory.vue?vue&type=template&id=41fc6354&scoped=true"
import script from "./certificateMaterialCategory.vue?vue&type=script&lang=js"
export * from "./certificateMaterialCategory.vue?vue&type=script&lang=js"
import style0 from "./certificateMaterialCategory.vue?vue&type=style&index=0&id=41fc6354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc6354",
  null
  
)

export default component.exports